import { DefaultDocumentSortFilter, getDocumentSortOptionFunc } from "components/filters/Filters/FilterTypes/DocumentSortFilterType";
import { type FilterValues } from "components/filters/FilterContext";
import { mapBookkeepingFilterToInstruction, mapCompanyFilterToInstruction, mapContactFilterToInstruction, mapDocumentProgressFilterToInstruction, mapKeywordFilterToInstruction, mapOnlyMySelectionFilterToInstruction, mapOwnersFilterToInstruction, mapPeriodFilterToInstruction, mapResponseToBookkeepingFilter, mapResponseToCompanyFilter, mapResponseToContactFilter, mapResponseToDocumentProgressFilter, mapResponseToKeywordFilter, mapResponseToOnlyMySelectionFilter, mapResponseToOwnerFilter, mapResponseToPeriodFilter, mapResponseToStatusFilter, mapStatusFilterToInstruction } from "components/filters/mappingUtils";

export const mapFilterValuesToInstruction = (
  filterSet: server.dto.FilterSets,
  filter: FilterValues,
  page: number,
  perPage: number
): server.dto.PaginatedDocumentInstruction => ({
  keyword: mapKeywordFilterToInstruction(filter.keyword),
  companyIds: mapCompanyFilterToInstruction(filter.company),
  contactIds: mapContactFilterToInstruction(filter.contact),
  lifeCycle: mapDocumentProgressFilterToInstruction(filter.documentProgress),
  bookkeepingIds: mapBookkeepingFilterToInstruction(filter.bookkeepings),
  statuses: mapStatusFilterToInstruction(filter.statuses),
  ownerUserIds: mapOwnersFilterToInstruction(filter.owners),
  period: mapPeriodFilterToInstruction(filter.period),
  order: filter.documentSort.sortOption.value,
  page,
  perPage,
  cache: filterSet,
  onlyMySelection: mapOnlyMySelectionFilterToInstruction(filter.onlyMySelection)
});

export const mapResponseToFilterValues = (documentType: server.dto.DocumentTypes) => (
  response: server.dto.ListDocumentFilters,
  values: FilterValues
): Partial<FilterValues> => ({
  keyword: mapResponseToKeywordFilter(response.keyword),
  company: mapResponseToCompanyFilter(response.companies),
  contact: mapResponseToContactFilter(response.contacts),
  documentProgress: mapResponseToDocumentProgressFilter(response.lifeCycle),
  bookkeepings: mapResponseToBookkeepingFilter(response.bookkeepings),
  statuses: mapResponseToStatusFilter(response.statuses, values.statuses),
  owners: mapResponseToOwnerFilter(response.ownerUsers),
  period: mapResponseToPeriodFilter(response.period),
  documentSort: {
    sortOption: (response.order !== "documentnumber_desc")
      ? getDocumentSortOptionFunc(documentType)(response.order)
      : getDocumentSortOptionFunc(documentType)(DefaultDocumentSortFilter)
  },
  onlyMySelection: mapResponseToOnlyMySelectionFilter(response.onlyMySelection)
});